import { Injectable } from '@angular/core';
import { UserInit } from '@features/user-init/user-init.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { UserInfoApiService } from '@rd/core/services/user-info-api/user-info-api.service';
import { HttpError } from '@rd/types';
import { UserInfoResponse } from '@rd/types/user-info.response';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import {
  LoadUserInfo,
  LoadUserInfoFail,
  LoadUserInfoSuccess,
} from '../actions/user-info.actions';

@Injectable()
export class UserInfoEffects {
  constructor(
    private actions$: Actions,
    private userInfoApiService: UserInfoApiService,
  ) {}

  loadUserInfo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LoadUserInfo),
      switchMap(() =>
        this.userInfoApiService.getUserInfo().pipe(
          map((userInfo: UserInfoResponse) => LoadUserInfoSuccess(userInfo)),
          catchError((error: HttpError) => of(LoadUserInfoFail(error))),
        ),
      ),
    ),
  );

  loadUserInfoOnUserInit$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserInit),
      map(() => LoadUserInfo()),
    ),
  );
}
